import SitegateStore from './store'
const Sitegate = () => import('./views/SitegateWrapper')
const dashboard = () => import('./views/SitegateDashboard')
const dashboardSingle = () => import('./views/SitegateSingleDashboard')

const install = function(Vue, options) {
  if (!options.store) {
    throw new Error('Please register the Site Gate Plugin by passing a Vuex Store')
  }

  Vue.component('sitegate', Sitegate)
  options.store.registerModule('sitegate', SitegateStore, { preserveState: options.store.state.sitegate !== undefined })
}

export default { dashboard, dashboardSingle, install }
